import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import { publicRoutes } from './publicRoutes'
import { privateRoutes } from './privateRoutes'
import constants from '@core/config/constants'
import storageService from '@core/persistence/localStorage/localStorageService'
// Layouts come from the active pack — swap packs in `src/app/layouts/index.ts`.
import { AppLayout, AuthLayout } from '@app/layouts'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
    component: AuthLayout,
    children: [...publicRoutes],
  },
  // Full-page private routes (no sidebar — auth required, AuthLayout shell)
  {
    path: '/',
    component: AuthLayout,
    children: [],
  },
  {
    path: '/',
    component: AppLayout,
    children: [...privateRoutes],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  const token = storageService.getItem(constants.LOCAL_STORAGE_KEYS.TOKEN)

  const isAuthenticated = Boolean(token)

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  const requiresGuest = to.matched.some((record) => record.meta.requiresGuest)

  if (requiresAuth && !isAuthenticated) {
    return { name: 'LOGIN', path: '/login' }
  }

  if (requiresGuest && isAuthenticated) {
    return { path: '/dashboard' }
  }

  return true
})

export default router
